import Enum from "@/enums/Enum";
import BaseEnum from "@/enums/BaseEnum";
/**
 * P判定
 */
export default class PHantei extends BaseEnum{
    static P_0 = {value: '0', name: 'Ｐマイナス'} as Enum
    static P_1 = {value: '1', name: 'Ｐ０～１'} as Enum
    static P_2 = {value: '2', name: 'Ｐ１'} as Enum
    static P_3 = {value: '3', name: 'Ｐ１～２'} as Enum
    static P_4 = {value: '4', name: 'Ｐ２'} as Enum
    static P_5 = {value: '5', name: 'Ｐ２～３'} as Enum
    static P_6 = {value: '6', name: 'Ｐ３'} as Enum
    static P_7 = {value: '7', name: 'Ｐ３～４'} as Enum
    static P_8 = {value: '8', name: 'Ｐ４'} as Enum
}
PHantei.values = [PHantei.P_0, PHantei.P_1, PHantei.P_2, PHantei.P_3, PHantei.P_4, PHantei.P_5, PHantei.P_6, PHantei.P_7, PHantei.P_8]
